import { apiCharacteristic } from '@spo/services/api';
import { useQuery } from '@tanstack/react-query';

export const useCharacteristicProfile = (
  smId: string,
  characteristicId: string,
  productNatureId: string,
) => {
  return useQuery({
    queryKey: ['useCharacteristicProfile', characteristicId],
    queryFn: async ({ signal }) => {
      if (!signal?.aborted) {
        const response = await apiCharacteristic.getCharacteristicProfile({
          smId,
          characteristicId,
          productNatureId,
          acceptLanguage: 'EN',
        });
        return response;
      }
    },
  });
};
